import { createFileRoute } from "@tanstack/react-router";
import Vallprognos from "../../app/views/vallPrognos";

export const Route = createFileRoute("/feed/vallprognos")({
  component: Vallprognos,
});
